/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { ContactRoute } from "@/routes/content";
import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import { SentryError } from "../../../shared/sentry/sentry";
import Styles from "./ErrorBoundary.module.scss";

type Props = {
  children: React.ReactNode;
};

class ErrorBoundary extends React.Component<Props> {
  state = {
    error: false,
  };

  componentDidMount(): void {
    const urlParams = new URLSearchParams(window.location.search);
    const sentryDebug = urlParams.get("sentryDebug");
    if (sentryDebug === "true") {
      const error = new Error("Sentry debug");
      console.error("Sentry debug: ", error);
      SentryError(error);
    }
  }

  componentDidCatch(error: Error) {
    this.setState({ error: true });
    console.error(error);
    SentryError(error);
  }

  componentDidUpdate(prevProps: Props) {
    if (this.state.error && prevProps !== this.props) {
      this.setState({ error: false });
    }
  }

  render() {
    if (this.state.error) {
      return <ErrorScreen />;
    }
    return this.props.children;
  }
}

const ErrorScreen = () => {
  const { t } = useTranslation();
  return (
    <div className={Styles.errorContainer}>
      <h1>{t("errorScreen.message")}</h1>
      <h3>
        <Trans i18nKey={"errorScreen.contact"} components={[<a key={"contact_route"} href={ContactRoute} />]} />
      </h3>
    </div>
  );
};

export default ErrorBoundary;
